import * as React from 'react';

import {Button} from 'shells/button/button';
import {LeadSummary} from 'shells/summary-popover/lead/lead-summary';
import {Body} from 'shells/typography/body';

import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {CollapsibleCardWidget} from '../../../core/card/collapsible-card-widget';
import {useLeadRecapSurvey} from '../../../internal-feedback/hooks/use-lead-recap-survey';
import {OpenableModals} from '../../../openable-modals/openable-modals';
import {useOpenableModal} from '../../../openable-modals/use-openable-modal';

import {useLeadSummary} from '../../shared/graphql/hooks/use-lead-summary';

type Props = {
    widget: Widget;
    leadId: string;
};

export function AiSummaryWidget(props: Props) {
    const {leadId} = props;

    const {entitySummary, isLoading, regenerateSummary, rateSummary, isSavingRating} =
        useLeadSummary(leadId);

    const {handleRate, openSurvey, SurveyModal} = useLeadRecapSurvey({
        onRate: rateSummary,
        entitySummaryId: entitySummary?.id,
    });

    const {onOpen: openLearnMoreModal} = useOpenableModal(OpenableModals.HELP_LEAD_RECAPS_MODAL);

    const recap = entitySummary && entitySummary.recap;
    const nextSteps = entitySummary && entitySummary.nextSteps;

    return (
        <CollapsibleCardWidget
            widget={props.widget}
            isLoading={isLoading}
            collapsedContent={
                <div className='px-16'>
                    <Body maintainLineBreaks={true}>{recap}</Body>
                </div>
            }
        >
            {!recap || !nextSteps ? (
                <div className='px-12'>
                    <Body size='small' color='light'>
                        Summary failed to generate. Please{' '}
                    </Body>
                    <Button onClick={regenerateSummary} variant='text-primary' noPadding={true}>
                        try again
                    </Button>
                </div>
            ) : (
                <LeadSummary
                    recap={recap}
                    nextSteps={nextSteps}
                    userRating={entitySummary ? entitySummary.userRating : undefined}
                    onRate={handleRate}
                    isSavingRating={isSavingRating}
                    onRefresh={regenerateSummary}
                    onFeedback={openSurvey}
                    isWidget={true}
                    entityId={leadId}
                    onLearnMore={openLearnMoreModal}
                />
            )}
            {SurveyModal}
        </CollapsibleCardWidget>
    );
}
